import comp from "./LearningCourseSelection";
export default comp;
